/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Pipeline Basic Auth";
const frontMatter = {};
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    code: "code",
    em: "em",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ..._provideComponents(),
    ...props.components
  };
  return <_components.table><_components.thead><_components.tr><_components.th>{"Name"}</_components.th><_components.th>{"Key"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Default"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.strong>{"HTTP Username"}</_components.strong></_components.td><_components.td><_components.code>{"http_user"}</_components.code></_components.td><_components.td>{"Basic auth username."}</_components.td><_components.td><_components.em>{"none"}</_components.em></_components.td></_components.tr><_components.tr><_components.td><_components.strong>{"HTTP Password"}</_components.strong></_components.td><_components.td><_components.code>{"http_passwd"}</_components.code></_components.td><_components.td>{"Basic auth password. Requires "}<_components.code>{"http_user"}</_components.code>{" to be set."}</_components.td><_components.td><_components.em>{"none"}</_components.em></_components.td></_components.tr></_components.tbody></_components.table>;
}

export default MDXLayout